interface Props {
  scheduled?: number;
  worked?: number;
  empty?: boolean;
  isExceeded?: boolean;
  compact?: boolean;
  children?: React.ReactNode | null | undefined;
}

const formatValue = (value: number) =>
  value > 0 ? value?.toFixed(2) : "\u00a0";

export const OvertimeProyEjecValues = ({
  scheduled = 0,
  worked = 0,
  empty = false,
  isExceeded,
  compact = false,
  children,
}: Props) => {
  const isOvertimeExceeded = worked > scheduled;
  const minHeight = compact ? "2rem" : "2.5rem";

  if (empty) {
    return (
      <div className="d-flex fs-5 tabular-nums" style={{ minHeight }}>
        <div className="d-flex flex-1">
          <div className="d-flex align-items-center justify-content-center border-end border-1 flex-1 flex-grow">
            <span className="text-muted py-2">{"\u00a0"}</span>
          </div>
          <div className="d-flex align-items-center justify-content-center flex-1 flex-grow">
            <span className="text-muted py-2">{"\u00a0"}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex tabular-nums" style={{ minHeight }}>
      <div className="d-flex flex-1">
        <div className="d-flex align-items-center justify-content-center border-end border-1 flex-1 flex-grow">
          <span
            className="text-dark py-2"
            style={{
              fontSize: "0.9rem",
            }}
          >
            {formatValue(scheduled)}
          </span>
        </div>

        <div className="d-flex align-items-center justify-content-center flex-1 flex-grow">
          <span
            style={{
              fontSize: "0.9rem",
            }}
            className={`py-2 ${isExceeded ? "text-danger" : isOvertimeExceeded ? "text-warning" : "text-dark"}`}
          >
            {formatValue(worked)}
          </span>
        </div>

        {children && children}
      </div>
    </div>
  );
};
